<template>
    <section>
        <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
            <!--open list-->
            <el-tab-pane label="To anyone" name="first">
                <el-form :model="outbound" label-position="top" label-width="220px" ref="outbound">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix" style="height: 30px;">
                            <span style="line-height:30px">Outbound items</span>
                            <el-button style="float: right; margin-left: 20px;" size="small" type="primary" @click="showAddInventory">Add Product</el-button>
                            <el-button style="float: right;" size="small" type="primary" @click="changeCustomizationPage(1)">Add customization Product</el-button>
                        </div>
                        <el-table stripe :data="outbound.items" highlight-current-row v-loading="listLoading"
                                  style="width: 100%;">
                            <el-table-column type="index">
                            </el-table-column>
                            <el-table-column label="Product" >
                                <template slot-scope="scope">
                                    <h3>{{scope.row.productNme}}</h3>
                                    <h3 v-if="scope.row.mainProductName">{{"Main Product : "+scope.row.mainProductName}}</h3>
                                    <p class="note">{{scope.row.upc}}</p>
                                    <p class="note" style="margin-bottom: 2px" v-for="(sub,index) in scope.row.items" :key="index">
                                        {{sub.qty}} x {{sub.productName}}({{sub.upc}}) <span style="color: #ff2218;" v-if="sub.service&&sub.service!=='None'">{{sub.service}}</span>
                                    </p>
                                </template>
                            </el-table-column>
                            <!--<el-table-column prop="users" label="Users" >
                            </el-table-column>-->
                            <el-table-column prop="warehouse" label="Warehouse" >
                            </el-table-column>
                            <el-table-column label="To ship"  width="200px">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.toShip" :min="1" :max="scope.row.qty?parseInt(scope.row.qty):99999" ></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column prop="qty" width="100px" label="Qty" >
                            </el-table-column>
                            <el-table-column label="Action" width="100px">
                                <template slot-scope="scope">
                                    <el-button size="small" type="danger" @click="removeInventory(scope.row)">Remove</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-row style="margin-top: 20px">
                            <el-form-item label="Package Label">
                                <el-upload style="width: 100%;" multiple :auto-upload="false" ref="upload"
                                           name="file" drag :action="uploadUrl"
                                           :http-request="upload"
                                           :file-list="fileList"
                                           :headers="headers">
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text"><em>click to upload</em> or drag and drop file</div>
                                </el-upload>
                            </el-form-item>
                            <el-row :gutter="20">
                                <el-col :span="6">
                                    <el-form-item label="Tracking number" prop="trackingNumber">
                                        <el-input v-model="outbound.trackingNumber" clearable></el-input>
                                        <p class="note">Optional.</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="Carrier" prop="carrier">
                                        <el-input v-model="outbound.carrier" clearable></el-input>
                                        <p class="note">Optional.</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="Carrier name" prop="carrierName">
                                        <el-input v-model="outbound.carrierName" clearable></el-input>
                                        <p class="note">Required if carrier is  'Other'.</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="User" prop="user">
                                        <el-select v-model="outbound.user" filterable clearable>
                                            <el-option v-for="(member,index) in members" :label="member.username"
                                                       :value="member.userNo" :key="index"></el-option>
                                        </el-select>
                                        <p class="note">By default, the user of the first shipment item will be notified.</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="6">
                                    <el-form-item label="Priority" prop="priority">
                                        <el-select v-model="outbound.priority" clearable>
                                            <el-option :value="0" label="Normal"></el-option>
                                            <el-option :value="1" label="Medium"></el-option>
                                            <el-option :value="2" label="Urgent"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
<!--                                <el-col :span="6">-->
<!--                                    <el-form-item label="Is Split Packages" prop="isSplitPackages">-->
<!--                                        <el-select v-model="outbound.isSplitPackages" clearable>-->
<!--                                            <el-option :value="0" label="No"></el-option>-->
<!--                                            <el-option :value="1" label="Yes"></el-option>-->
<!--                                        </el-select>-->
<!--                                    </el-form-item>-->
<!--                                </el-col>-->
                                <el-col :span="6">
                                    <el-form-item label="Numb of box Per Shipment" prop="splitPackagesNum">
                                        <el-input-number v-model="outbound.splitPackagesNum" :min="0" :max="99999" ></el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="40">
                                <el-col :span="24">
                                    <el-form-item label="Instruction" prop="instruction">
                                        <el-row>
                                            <el-select placeholder="Append preset" clearable filterable v-model="selectedInstruction" @change="changeInstruction" style="margin-bottom: 10px">
                                                <el-option v-for="(item,index) in instructionTemps" :key="index" :value="item" :label="item.instructionName"></el-option>
                                            </el-select>
                                            <el-link style="margin-left: 20px" @click="getInstructionListByPage">Instruction Template</el-link>
                                        </el-row>
                                        <!--                                        <el-input type="textarea" v-model="outbound.instruction" rows="5"></el-input>-->
                                        <quill-editor v-model="outbound.instruction" ref="myQuillEditor" :options="editorOption"></quill-editor>
                                        <p class="note">Instruction (optional) will only appear in the email sent to the user.</p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="Note" prop="note">
                                        <!--                                        <el-input type="textarea" v-model="outbound.note" rows="5"></el-input>-->
                                        <quill-editor v-model="outbound.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                                        <p class="note">Store essential information in note for future reference.</p>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-button type="primary" class="pull-right" :loading="loading" @click="handleOutbound">Submit</el-button>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-card>
                </el-form>
            </el-tab-pane>
            <!--Groups list-->
            <el-tab-pane label="Working" name="second">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.workingFilter" placeholder="Product Name" clearable @keyup.enter.native="getWorkingOutboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getWorkingOutboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filters.workingMainFilter" placeholder="Main Product" clearable @keyup.enter.native="getWorkingOutboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getWorkingOutboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportOutboundByType','working.xls','1')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="workingList" highlight-current-row v-loading="workingLoading" style="width: 100%;">
                    <el-table-column prop="outboundId" label="#" min-width="3%">
                    </el-table-column>
                    <el-table-column label="Product Name" min-width="30%">
                        <template slot-scope="scope">
                            <div v-html="scope.row.productName"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="instruction" label="Instruction" min-width="22%">
                        <template slot-scope="scope">
                            <div v-html="scope.row.instruction"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Note"  min-width="15%">
                        <template slot-scope="scope">
                            <div v-html="scope.row.note"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="users" label="Users" min-width="8%">
                    </el-table-column>
                    <el-table-column prop="splitPackagesNum" label="Split Package Num"  min-width="5%">
                    </el-table-column>
                    <el-table-column prop="outboundDate" label="Outbound Date" min-width="10%">
                    </el-table-column>
                    <el-table-column label="Action" min-width="12%">
                        <template slot-scope="scope">
                            <el-button size="small" @click="download(scope.row.outboundId)">Package Label</el-button>
                            <el-button size="small" type="danger" @click="closeOutbound(scope.row.outboundId)">Cancel</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeWorkingList" :page-size="pageSize" :total="workingTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <!--Invitations list-->
            <el-tab-pane label="Archived" name="third">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.archivedFilter" placeholder="Product Name" clearable @keyup.enter.native="getArchivedOutboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getArchivedOutboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filters.archivedMainFilter" placeholder="Main Product" clearable @keyup.enter.native="getArchivedOutboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getArchivedOutboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportOutboundByType','archived.xls','2')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="archivedList" highlight-current-row v-loading="archivedLoading"
                          style="width: 100%;">
                    <el-table-column prop="outboundId" label="#" width="100px">
                    </el-table-column>
                    <el-table-column label="Product Name">
                        <template slot-scope="scope">
                            <div v-html="scope.row.productName"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="instruction" label="Instruction"  >
                        <template slot-scope="scope">
                            <div v-html="scope.row.instruction"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Note">
                        <template slot-scope="scope">
                            <div v-html="scope.row.note"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="users" label="Users" >
                    </el-table-column>
                    <el-table-column prop="splitPackagesNum" label="Split Package Num" >
                    </el-table-column>
                    <el-table-column prop="outboundDate" label="Outbound Date" >
                    </el-table-column>
                    <el-table-column label="Action" width="300">
                        <template slot-scope="scope">
                            <el-button size="small" @click="download(scope.row.outboundId)">Package Label</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeArchivedList"
                                   :page-size="pageSize" :total="archivedTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Cancelled" name="fourth">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.closeFilter" placeholder="Product Name" clearable @keyup.enter.native="getCloseOutboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getCloseOutboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filters.closeMainFilter" placeholder="Main Product" clearable @keyup.enter.native="getCloseOutboundList">
                                <el-button slot="append" icon="el-icon-search" @click="getCloseOutboundList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportOutboundByType','Cancelled.xls','3')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="closeList" highlight-current-row v-loading="closeLoading"
                          style="width: 100%;">
                    <el-table-column prop="outboundId" label="#" width="100px">
                    </el-table-column>
                    <el-table-column label="Product Name">
                        <template slot-scope="scope">
                            <div v-html="scope.row.productName"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="instruction" label="Instruction"  >
                        <template slot-scope="scope">
                            <div v-html="scope.row.instruction"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Note">
                        <template slot-scope="scope">
                            <div v-html="scope.row.note"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="users" label="Users" >
                    </el-table-column>
                    <el-table-column prop="splitPackagesNum" label="Split Package Num" >
                    </el-table-column>
                    <el-table-column prop="outboundDate" label="Outbound Date" >
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeCloseList"
                                   :page-size="pageSize" :total="closeTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Transfer To" name="five">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true">
                        <el-form-item :inline="true">
                            <el-input v-model="filters.productFilter" placeholder="Product Name" clearable @keyup.enter.native="getTransferProductList">
                                <el-button slot="append" icon="el-icon-search" @click="getTransferProductList"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-table stripe :data="productList" highlight-current-row v-loading="productLoading"
                          style="width: 100%;">
                    <el-table-column label="#" prop="productNo" width="80px">
                    </el-table-column>
                    <el-table-column prop="product" label="Product" width="400px">
                        <template slot-scope="scope">
                            {{scope.row.condition}} - <b>{{scope.row.productName}}</b> ({{scope.row.createDate}})
                            <p>{{scope.row.upc}}</p>
                            <p class="note">{{scope.row.note}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stock" label="FBM">
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="showWarehouseFBM(scope.row.productNo)">Transfer</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleProductPageChange"
                                   :page-size="pageSize" :total="productTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
            
            <el-tab-pane label="Transfer Logs" name="six" :key="'transferLogsTab'">
                <el-table stripe :data="transferLogsList" highlight-current-row v-loading="transferLogsLoading" style="width: 100%;">
                    <el-table-column prop="id" label="#">
                    </el-table-column>
                    <el-table-column prop="transferNo" label="Transfer#">
                    </el-table-column>
                    <el-table-column prop="userName" label="Transferer">
                    </el-table-column>
                    <el-table-column prop="transferToUserName" label="Acceptor">
                    </el-table-column>
                    <el-table-column prop="productName" label="Product Name">
                    </el-table-column>
                    <el-table-column prop="qty" label="Qty">
                    </el-table-column>
                    <el-table-column prop="warehouseAddress" label="Transfer Warehouse Address">
                    </el-table-column>
                    <el-table-column prop="transferToAddress" label="Acceptor Warehouse Address">
                    </el-table-column>
                    <el-table-column prop="createDate" label="Transfer Date">
                    </el-table-column>
                    <el-table-column prop="moved" label="Checked">
                        <template slot-scope="scope">
                            <div :style="{ color: scope.row.moved ? 'green' : 'red' }">
                                {{ scope.row.moved ? "Yes" : "No" }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateDate" label="Checked Date">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="getTrasferUserLogs" :page-size="transferLogsPageSize"
                                :total="transferLogsWorkingTotal" style="float:right;">
                    </el-pagination>
                </el-col>

            </el-tab-pane>
            
        </el-tabs>

        <el-dialog title="Product Summary" width="80%" :visible.sync="inventroySummary" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item>
                        <el-input v-model="filters.inventoryProductSummary" @keyup.enter.native="searchInventorySummary" placeholder="ProductName or UPC" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" v-on:click="searchInventorySummary">Search</el-button>
                    </el-form-item>
                    <el-form-item style="float:right;">
                        <el-select clearable placeholder="Filter by user" v-model="filters.inventorySummaryNurse" :filterable="true" @change="getInventorySummaryByUser">
                            <el-option v-for="(nurse,index) in members" :label="nurse.username"
                                       :value="nurse.userNo" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-col>
            <div v-if="!filters.inventorySummaryNurse">
                <el-table stripe :data="inventoriesSummary" highlight-current-row v-loading="inventorySummaryLoading" style="width: 100%;">
                    <el-table-column label="#" prop="productNo">
                    </el-table-column>
                    <el-table-column prop="productNme" label="Product">
                    </el-table-column>
                    <el-table-column prop="qty" label="Qty">
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope">
                            <el-button @click="getInventory(scope.row.productNo)">Detail</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleInventorySummaryPageChange"
                                   :page-size="pageSize" :total="inventorySummaryTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </div>
            <div v-else>
                <el-table stripe :data="inventoriesSummaryByUser" highlight-current-row v-loading="inventorySummaryLoading"
                          style="width: 100%;">
                    <el-table-column label="#" prop="productNo">
                    </el-table-column>
                    <el-table-column prop="productNme" label="Product">
                    </el-table-column>
                    <el-table-column prop="warehouseUserName" label="UserName">
                    </el-table-column>
                    <el-table-column prop="warehouse" label="Warehouse">
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="qty" label="Qty">
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope">
                            <el-button @click="selectInventory(scope.row)">{{scope.row.selected?'selected':'select'}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleInventorySummaryByUserPageChange"
                                   :page-size="pageSize" :total="inventorySummaryByUserTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="inventroySummary = false">Close</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Add Product" width="80%" :visible.sync="addInventory" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item>
                        <el-input v-model="filters.inventoryProduct" placeholder="ProductName" @keyup.enter.native="getInventory(null)" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" v-on:click="getInventory(null)">Search</el-button>
                    </el-form-item>
                    <el-form-item style="float:right;">
                        <el-select clearable placeholder="Filter by user" v-model="filters.inventoryNurse" :filterable="true" @change="getInventory(null)">
                            <el-option v-for="(nurse,index) in members" :label="nurse.username"
                                       :value="nurse.userNo" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-table stripe :data="inventories" highlight-current-row v-loading="inventoryLoading"
                      style="width: 100%;">
                <el-table-column label="#" prop="productNo">
                </el-table-column>
                <el-table-column prop="productNme" label="Product">
                </el-table-column>
                <el-table-column prop="warehouseUserName" label="UserName">
                </el-table-column>
                <el-table-column prop="warehouse" label="Warehouse">
                    <template slot-scope="scope">
                        <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="qty" label="Qty">
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button @click="selectInventory(scope.row)">{{scope.row.selected?'selected':'select'}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="handleInventoryPageChange"
                               :page-size="pageSize" :total="inventoryTotal" style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addInventory = false">Close</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Customization Product" width="80%" :visible.sync="customizationVisible" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters" @submit.native.prevent>
                    <el-form-item>
                        <el-input v-model="filters.customizationName" style="width:400px" placeholder="Template Name or Mian Product" clearable @keyup.enter.native="getCustomizationProduct">
                            <el-button slot="append" icon="el-icon-search" @click="getCustomizationProduct"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="openNewCustomizationWindow">Add</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-table stripe :data="customizationProduct" highlight-current-row v-loading="customizationLoading"
                      style="width: 100%;">
                <el-table-column label="#" prop="id">
                </el-table-column>
                <el-table-column prop="templateName" label="Template Name">
                </el-table-column>
                <el-table-column prop="mainProductName" label="Main Product">
                </el-table-column>
                <el-table-column prop="product" label="Product">
                    <template slot-scope="scope">
                        <h3>{{scope.row.product}}</h3>
                        <p class="note" v-for="(sub,index) in scope.row.items" :key="index">
                            {{sub.productName}} * {{sub.qty}} <span style="color: #ff2218;" v-if="sub.service && sub.service!=='None'">({{sub.service}})</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="warehouse" label="Warehouse">
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button size="small" @click="selectCustomization(scope.row)" type="primary">Select</el-button>
                        <el-button size="small" @click="eitCustomization(scope.row)" type="primary">Edit</el-button>
                        <el-button size="small" type="danger" @click="deleteCustomization(scope.row.id)">Delete</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--<el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="customizationProduct.length" style="float:right;">
                </el-pagination>
            </el-col>-->
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="customizationVisible = false">Close</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Add Customization Product" width="80%" :visible.sync="addCustomizationVisible" :close-on-click-modal="false">
            <el-form :model="customization" label-width="220px" ref="customization" :rules="customizationRule" >
                <el-form-item label="Warehouse" prop="warehouse">
                    <el-select v-model="customization.warehouse" @change="getProductsByWarehouseId">
                        <el-option v-for="(w,index) in warehouses" :label="w.state+' '+w.city+' '+w.address" :value="w.warehouseNo" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <div v-if="customization.warehouse">
                    <el-form-item label="Main Product" prop="mainProduct">
                        <el-select v-model="customization.mainProduct" style="width:100%" :filterable="true">
                            <el-option v-for="(product,index) in inventories" :key="index" :value="product.productNo" :label="product.productNme + '(Stock:' + product.stock + ')'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Main Product Qty" prop="mainProductQty">
                        <el-input-number :min="1" v-model="customization.mainProductQty"></el-input-number>
                    </el-form-item>
                    <el-form-item label="Template Name" prop="name">
                        <el-input type="text" v-model="customization.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Products">
                        <el-form-item>
                            <el-button type="primary" @click="addAccessories">Add Product</el-button>
                        </el-form-item>
                        <el-table stripe :data="customization.sub" highlight-current-row v-loading="listLoading"
                                  style="width: 100%;">
                            <el-table-column type="index">
                            </el-table-column>
                            <el-table-column label="Product">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.productNo" style="width:100%" :filterable="true">
                                        <el-option v-for="(product,index) in inventories" :key="index" :value="product.productNo" :label="product.productNme + '(Stock:' + product.stock + ')'"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="Qty" width="200px">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.qty"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="Service" width="200px">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.service" style="width:100%" :filterable="true">
                                        <el-option value="None">None</el-option>
                                        <el-option v-for="(service,index) in serviceList" :key="index" :value="service" :label="service"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="Action" width="100px">
                                <template slot-scope="scope">
                                    <el-button size="small" type="danger" @click="deleteSub(scope.row)">Delete</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addCustomizationVisible = false">Close</el-button>
                <el-button type="primary" @click.native="addCustomizationTemplate" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Edit Customization Product" width="80%" :visible.sync="editCustomizationVisible" :close-on-click-modal="false">
            <el-form :model="editCustomization" label-width="220px" ref="editCustomization" :rules="customizationRule" >
                <el-form-item label="Warehouse" prop="warehouse">
                    <el-select v-model="editCustomization.warehouse" @change="getProductsByWarehouseId">
                        <el-option v-for="(w,index) in warehouses" :label="w.state+' '+w.city+' '+w.address" :value="w.warehouseNo" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <div v-if="editCustomization.warehouse">
                    <el-form-item label="Template Name" prop="name">
                        <el-input type="text" v-model="editCustomization.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Main Product" prop="mainProduct">
                        <el-select v-model="editCustomization.mainProduct" style="width:100%" :filterable="true">
                            <el-option v-for="(product,index) in inventories" :key="index" :value="product.productNo" :label="product.productNme + '(Stock:' + product.stock + ')'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Main Product Qty" prop="mainProductQty">
                        <el-input-number :min="1" v-model="editCustomization.mainProductQty"></el-input-number>
                    </el-form-item>
                    <el-form-item label="Products">
                        <el-form-item>
                            <el-button type="primary" @click="addEditAccessories">Add Product</el-button>
                        </el-form-item>
                        <el-table stripe :data="editCustomization.sub" highlight-current-row v-loading="listLoading"
                                  style="width: 100%;">
                            <el-table-column type="index">
                            </el-table-column>
                            <el-table-column label="Product">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.productNo" style="width:100%" :filterable="true">
                                        <el-option v-for="(product,index) in inventories" :key="index" :value="product.productNo" :label="product.productNme + '(Stock:' + product.stock + ')'"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="Qty" width="200px">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.qty"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="Service" width="200px">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.service" style="width:100%" :filterable="true">
                                        <el-option value="None">None</el-option>
                                        <el-option v-for="(service,index) in serviceList" :key="index" :value="service" :label="service"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="Action" width="100px">
                                <template slot-scope="scope">
                                    <el-button size="small" type="danger" @click="deleteEditSub(scope.row)">Delete</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editCustomizationVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editCustomizationTemplate" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Instruction Template" width="80%" :visible.sync="instructionTemplateVisiable" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="addInstructionVisible=true">Add</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-table stripe :data="instructionListPage" highlight-current-row v-loading="instructionLoading"
                      style="width: 100%;">
                <el-table-column label="#" prop="id">
                </el-table-column>
                <el-table-column prop="instructionName" label="Instruction Name">
                </el-table-column>
                <el-table-column label="Text">
                    <template slot-scope="scope">
                        <div v-html="scope.row.instructionText"></div>
                    </template>
                </el-table-column>
                <el-table-column label="Note">
                    <template slot-scope="scope">
                        <div v-html="scope.row.instructionNote"></div>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="editInstruction(scope.row)">Edit</el-button>
                        <el-button type="danger" @click="deleteInstruction(scope.row.id)">Delete</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="handleInventoryPageChange"
                               :page-size="pageSize" :total="instructionTotal" style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="instructionTemplateVisiable = false">Close</el-button>
            </div>
        </el-dialog>

        <!--编辑界面-->
        <el-dialog title="Add Instruction" width="80%" :visible.sync="addInstructionVisible" :close-on-click-modal="false">
            <el-form :model="addInstruction" label-width="220px"  ref="addInstruction" :rules="addInstructionRule">
                <el-form-item label="Name" prop="name">
                    <el-input v-model="addInstruction.name"></el-input>
                </el-form-item>
                <el-form-item label="Text" prop="text">
                    <!--                    <el-input type="textarea" rows="5" v-model="addInstruction.text" :min="0"></el-input>-->
                    <quill-editor v-model="addInstruction.text" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <!--                    <el-input type="textarea" rows="5" v-model="addInstruction.note" :min="0"></el-input>-->
                    <quill-editor v-model="addInstruction.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addInstructionVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleAddInstruction" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Edit Instruction" width="80%" :visible.sync="editInstructionVisible" :close-on-click-modal="false">
            <el-form :model="editInstructionObj" label-width="220px"  ref="editInstructionObj" :rules="addInstructionRule">
                <el-form-item label="Name" prop="name">
                    <el-input v-model="editInstructionObj.name"></el-input>
                </el-form-item>
                <el-form-item label="Text" prop="text">
                    <!--                    <el-input type="textarea" rows="5" v-model="addInstruction.text" :min="0"></el-input>-->
                    <quill-editor v-model="editInstructionObj.text" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <!--                    <el-input type="textarea" rows="5" v-model="addInstruction.note" :min="0"></el-input>-->
                    <quill-editor v-model="editInstructionObj.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editInstructionVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleEditInstruction" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Product FBM List" width="80%" :visible.sync="fbmModelVisiable" :close-on-click-modal="false">
            <el-table stripe :data="fbmDetail" highlight-current-row v-loading="fbmLoading"
                      style="width: 100%;">
                <el-table-column type="index">
                </el-table-column>
                <el-table-column prop="productNme" label="Product">
                </el-table-column>
                <el-table-column prop="warehouseUserName" label="UserName">
                </el-table-column>
                <el-table-column prop="warehouse" label="Warehouse">
                </el-table-column>
                <el-table-column prop="qty" label="Qty">
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="showTransfer(scope.row.productNo,scope.row.warehouseNo)">Transfer To</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="handleInventoryDetailPageChange"
                               :page-size="pageSize" :total="fbmTotal" style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="fbmModelVisiable = false">Close</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Transfer To" width="40%" :visible.sync="transferModelVisiable" :close-on-click-modal="false">
            <el-form :model="transferForm" label-width="220px" ref="transferForm" :rules="transferRule">
                <el-form-item label="Product Name">
                    <el-input :disabled="true" v-model="transferForm.productName"></el-input>
                </el-form-item>
                <el-form-item label="Warehouse">
                    <el-input :disabled="true" v-model="transferForm.warehouse"></el-input>
                </el-form-item>
                <el-form-item label="UPC">
                    <el-input :disabled="true" v-model="transferForm.upc"></el-input>
                </el-form-item>
                <el-form-item label="Qty">
                    <el-input :disabled="true" v-model="transferForm.qty"></el-input>
                </el-form-item>
                <el-form-item label="Transfer To" prop="to">
                    <el-input v-model="transferForm.to" placeholder="User Name"></el-input>
                </el-form-item>
                <el-form-item label="Transfer Qty" prop="transferQty">
                    <el-input-number v-model="transferForm.transferQty" :max="parseInt(transferForm.qty)"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="transferModelVisiable = false">Close</el-button>
                <el-button type="primary" @click.native="transferTo" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <!--add group界面-->
    </section>
</template>


<script>
    import $ from "jquery"
    import util from '../../common/js/util'
    import {getDoctorMemberList, getInvitations, invitationRegister, invitationList,getDoctorNurse} from '../../api/memberService';
    import {getInventory, getServiceList} from "../../api/inventoryService";
    import {transferTo,getProductFBM,getTransferList,deleteInstruction,muploadET,updateOutboundStatus,getOutboundList,deleteCustomizationTemplate,addCustomizationTemplate ,getProductsByWarehouseId,outbound,getInventoryList,getCustomizationProduct,getInstructionList,addInstruction,getInventorySummary,getInstructionListByPage, getTransferUserInfoByDoctorNo} from "../../api/outboundService";
    import {getCurrentWarehouse} from "../../api/warehouseService";
    import ElButton from "element-ui/packages/button/src/button";
    import ElLink from "element-ui/packages/link/src/main";
    import ElOption from "element-ui/packages/select/src/option";
    import ElInput from "element-ui/packages/input/src/input";
    import {defaultPageSize,serverUrl} from "../../globalVar";
    import { quillEditor } from 'vue-quill-editor';
    import {postExportExcel} from "../../api/exportService";
    import ElInputNumber from "element-ui/packages/input-number/src/input-number";

    export default {
        components: {
            ElInputNumber,
            ElInput,
            ElOption,
            ElLink,
            ElButton},
        data() {
            return {
                editorOption: {
                    theme: "snow", // or 'bubble'
                    placeholder: "Note",
                    height:"400px",
                    modules: {
                        toolbar: {
                            container: [
                                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                                ["link"] // 链接、图片、视频
                            ]
                        }
                    }
                },
                activeName: "first",
                filters: {
                    workingFilter:"",
                    workingMainFilter:"",
                    archivedFilter:"",
                    archivedMainFilter:"",
                    closeFilter:"",
                    closeMainFilter:"",
                    inventoryProduct:"",
                    inventoryProductSummary:"",
                    inventoryNurse:"",
                    inventorySummaryNurse:"",
                    customizationName:"",
                    name: '',
                    transferFilter:"",
                    productFilter:"",
                    fbmFilter:""
                },
                headers:{
                    Authorization:window.sessionStorage.getItem("authorization")
                },
                uploadUrl:serverUrl+"/outboundFile/upload",

                pageSize:defaultPageSize,

                inventoryLoading:false,
                inventorySummaryLoading:false,

                inventorySummaryPage:1,
                inventorySummaryTotal:0,

                inventorySummaryByUserPage:1,
                inventorySummaryByUserTotal:0,

                inventoryPage:1,
                inventoryTotal:0,

                customizationPage:1,
                customizationTotal:0,
                customizationLoading:false,

                instructionTemps:[],
                instruction:{},

                workingList:[],
                workingPage:1,
                workingTotal:0,
                workingLoading:false,

                archivedList:[],
                archivedPage:1,
                archivedTotal:0,
                archivedLoading:false,

                instructionTemplateVisiable:false,
                instructionListPage:[],
                instructionPage:1,
                instructionTotal:0,
                instructionLoading:false,

                closeList:[],
                closePage:1,
                closeTotal:0,
                closeLoading:false,

                transferList:[],
                transferPage:1,
                transferTotal:0,
                transferLoading:false,
                transferModelVisiable:false,

                transferLogsPage: 1,
                transferLogsPageSize: 50,
                transferLogsWorkingTotal: 0,
                transferLogsList: [],
                transferLogsLoading: false,

                productList:[],
                productPage:1,
                productTotal:0,
                productLoading:false,

                fbmDetail:[],
                fbmPage:1,
                fbmTotal:0,
                fbmLoading:false,

                serviceList:[],

                editCustomizationVisible:false,
                addCustomizationVisible:false,
                customizationProduct:[],
                addInstructionVisible:false,
                editInstructionVisible:false,
                workingOutboundList:[],
                inventories:[],
                inventoriesSummary:[],
                inventoriesSummaryByUser:[],
                outboundItems: [],
                archivedOutbound: [],
                total: 0,
                invitationTotalPage: 0,
                invitationPage: 1,
                listLoading: false,
                sels: [],//列表选中列
                customizationVisible:false,
                addInventory: false,
                inventroySummary: false,
                fbmModelVisiable:false,

                currentInventroy:"",

                currentDetailNo:"",

                nurseList:[],
                warehouses:[],

                loading: false,
                //新增界面数据
                outbound: {
                    id: "",
                    warehouseNo:"",
                    items:[],
                    packageLabel:"",
                    trackingNumber:"",
                    carrier:"",
                    carrierName:"",
                    user:"",
                    note:"",
                    instruction:"",
                    priority:0,
                    // isSplitPackages:1,
                    splitPackagesNum:0,
                    fileId:"",
                    mainProduct:"",
                    mainProductName:""
                },

                selectedInstruction:null,

                members:[],

                addInstructionRule:{
                    name: [
                        {required: true, message: 'Name is required.', trigger: 'blur'}
                    ]
                },

                customizationRule:{
                    warehouse:[
                        {required: true, message: 'Warehouse is required.', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: 'Template name is required.', trigger: 'blur'}
                    ],
                    mainProduct:[
                        {required: true, message: 'Main Product is required.', trigger: 'blur'}
                    ],
                    mainProductQty:[
                        {required: true, message: 'Main Product Qty is required.', trigger: 'blur'}
                    ]
                },

                transferRule:{
                    to:[
                        {required: true, message: 'Transfer To is required.', trigger: 'blur'}
                    ],
                    transferQty:[
                        {required: true, message: 'Transfer Qty is required.', trigger: 'blur'},
                        {validator:this.checkQuantity, trigger: 'blur'}
                    ]
                },

                addInstruction:{
                    name:"",
                    text:"",
                    note:""
                },
                editInstructionObj:{
                    name:"",
                    text:"",
                    note:"",
                    id:""
                },
                customization:{
                    name:"",
                    warehouse:"",
                    mainProduct:"",
                    mainProductQty:"",
                    sub:[],
                },

                editCustomization:{
                    id:"",
                    name:"",
                    warehouse:"",
                    sub:[],
                    mainProduct:"",
                    mainProductQty:""
                },

                transferForm:{
                    productNo:"",
                    productName:"",
                    warehouseNo:"",
                    warehouse:"",
                    qty:"",
                    to:"",
                    transferQty:"",
                    upc:""
                },
                fileList:[],
                uploadForm:new FormData(),
                currentUser: null,
            }
        },
        methods: {
            checkQuantity(rule, value, callback) {
                if (!value>0) {
                    return callback(new Error('Quantity must more than 1.'));
                }else{
                    callback();
                }
            },
            exportExcel(url,fileName,type){
                let param = {
                    url:url,
                    fileName:fileName,
                    status:type
                }
                postExportExcel(param).then(function(){

                })
            },
            closeOutbound(id){
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(()=>{
                    let param = {
                        outboundNo:id,
                        status:3
                    };
                    updateOutboundStatus(param).then((data)=>{
                        if(data.status===200){
                            this.$message.success(data.message);
                            this.getWorkingOutboundList();
                            this.getCloseOutboundList();
                        }else{
                            this.$message.error(data.message)
                        }
                    })
                }).catch(()=>{})
            },
            download(id){
                window.open(serverUrl+"/outboundFile/exportPackageLabelImageById?outboundNo="+id,"_blank")
            },
            deleteCustomization(id){
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(() => {
                    deleteCustomizationTemplate({customization_id:id}).then((res)=>{
                        if(res.status===200){
                            this.$message.success(res.message);
                            this.getCustomizationProduct();
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {

                });
            },
            deleteEditSub(row){
                this.editCustomization.sub.splice(this.editCustomization.sub.indexOf(row),1)
            },
            deleteSub(row){
                this.customization.sub.splice(this.customization.sub.indexOf(row),1)
            },
            openNewCustomizationWindow() {
                this.addCustomizationVisible=true;
                this.$nextTick(() => {
                    this.$refs.customization.resetFields();
                })
            },
            addCustomizationTemplate(){
                this.$refs.customization.validate((valid)=>{
                    if(valid){
                        let items = [];
                        let products = this.customization.sub;
                        for(let i=0;i<products.length;i++){
                            if(!products[i].productNo){
                                this.$message.error("You must select a product for each rows.");
                                return;
                            }
                            if(products[i].productNo==this.customization.mainProduct){
                                this.$message.error("You select a sub product same with main product, please delete this product or replace.");
                                return;
                            }
                            if(!products[i].service){
                                this.$message.error("You must select a service for each rows.");
                                return;
                            }
                            let exsit = items.find((f)=>{
                                return f.productNo==products[i].productNo;
                            })
                            if(exsit){
                                this.$message.error("Duplicate product in the list.");
                                return;
                            }else{
                                items.push({productNo:products[i].productNo,qty:products[i].qty,service:products[i].service?products[i].service:"None"});
                            }
                        }
                        // if(items.length===0){
                        //     this.$message.error("Please add a product.");
                        //     return;
                        // }
                        let param = {
                            items:items,
                            templateName:this.customization.name,
                            warehouseNo:this.customization.warehouse,
                            product_no:this.customization.mainProduct,
                            mainProductQty:this.customization.mainProductQty
                        }
                        this.loading = true;
                        addCustomizationTemplate(param).then((data)=>{
                            this.loading = false;
                            if(data.status===200){
                                this.addCustomizationVisible = false;
                                this.getCustomizationProduct();
                                this.$refs.customization.resetFields();
                                this.customization.sub = [];
                                this.$message.success(data.message);
                            }else{
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            editCustomizationTemplate(){
                this.$refs.editCustomization.validate((valid)=>{
                    if(valid){
                        let items = [];
                        let products = this.editCustomization.sub;
                        for(let i=0;i<products.length;i++){
                            if(!products[i].productNo){
                                this.$message.error("You must select a product for each rows.");
                                return;
                            }
                            if(products[i].productNo==this.editCustomization.mainProduct){
                                this.$message.error("You select a sub product same with main product, please delete this product or replace.");
                                return;
                            }
                            if(!products[i].qty){
                                this.$message.error("You must set quantity for each rows.");
                                return;
                            }
                            if(!products[i].service){
                                this.$message.error("You must select a service for each rows.");
                                return;
                            }
                            let exsit = items.find((f)=>{
                                return f.productNo==products[i].productNo;
                            })
                            if(exsit){
                                this.$message.error("Duplicate product in the list.");
                                return;
                            }else{
                                items.push({productNo:products[i].productNo,qty:products[i].qty,service:products[i].service?products[i].service:"None"});
                            }
                        }
                        // if(items.length===0){
                        //     this.$message.error("Please add a product.");
                        //     return;
                        // }
                        let param = {
                            customizationOutboundId:this.editCustomization.id,
                            items:items,
                            templateName:this.editCustomization.name,
                            warehouseNo:this.editCustomization.warehouse,
                            product_no:this.editCustomization.mainProduct,
                            mainProductQty:this.editCustomization.mainProductQty
                        };
                        this.loading = true;
                        addCustomizationTemplate(param).then((data)=>{
                            this.loading = false;
                            if(data.status===200){
                                this.editCustomizationVisible = false;
                                this.getCustomizationProduct();
                                this.$refs.editCustomization.resetFields();
                                this.editCustomization.sub = [];
                                this.$message.success(data.message);
                            }else{
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            getProductsByWarehouseId(id){
                if(this.customization.warehouse||id){
                    this.customization.sub= [];
                    this.editCustomization.sub= [];
                    return getProductsByWarehouseId({warehouseNo:this.customization.warehouse||id}).then((data)=>{
                        if(data.status===200){
                            let param = {
                                warehouseNo: this.customization.warehouse||id
                            }
                            getServiceList(param).then((data)=>{
                                if(data.status===200){
                                    this.serviceList = data.result;
                                }
                            })
                            this.inventories = data.result;
                        }
                    })
                }else{
                    this.inventories = [];
                }
            },
            handleOutbound(){
                if(this.outbound.items.length===0){
                    this.$message.error("You must select a product to shipment.");
                    return;
                }
                if(!this.outbound.user){
                    this.$message.error("You must select a user to notify.");
                    return;
                }
                if(this.outbound.splitPackagesNum < 1){
                    this.$message.error("You must set Numb of box Per Shipment greater than 0.");
                    return;
                }
                let data  = [];
                for (let i=0;i<this.outbound.items.length;i++){
                    let item = this.outbound.items[i];
                    if(item.items){
                        if(!item.toShip){
                            this.$message.error("Toship can't be empty.");
                            return;
                        }else{
                            let sub = item.items;
                            for(let j=0;j<sub.length;j++){
                                data.push({toShip:item.toShip*sub[j].qty,productNo:sub[j].productNo,service:sub[j].service})
                            }
                        }
                    }else{
                        if(item.toShip){
                            data.push({toShip:item.toShip,qty:item.qty,inboundNo:item.boundId,type:item.type,productNo:item.productNo,service:item.service})
                        }else{
                            this.$message.error("Toship can't be empty.");
                            return;
                        }
                    }

                }

                let param = {
                    data:data,
                    fileNo:"",
                    carrier:this.outbound.carrier,
                    carrierName:this.outbound.carrierName,
                    instruction:this.outbound.instruction,
                    note:this.outbound.note,
                    notifiyUserNo:this.outbound.user,
                    priority:this.outbound.priority,
                    // isSplitPackages:this.outbound.isSplitPackages,
                    splitPackagesNum:this.outbound.splitPackagesNum,
                    tracking:this.outbound.trackingNumber,
                    warehouseNo:this.outbound.warehouseNo,
                    mainProduct:this.outbound.mainProduct
                }

                //先上传文件
                this.uploadForm = new FormData();
                this.$refs.upload.submit();
                let files = this.uploadForm.get("file");
                if(!files){
                    this.$message.error("Please upload package label before submit.")
                    return;
                }
                this.loading = true;
                $.ajax({
                    url:serverUrl+'/outboundFile/uploadFiles',
                    type:"POST",
                    data: this.uploadForm,
                    cache: false,
                    processData: false,
                    contentType: false,
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("Authorization", window.sessionStorage.getItem("authorization"));
                    }
                }).then(response=>{
                    if(response.status===200){
                        param.fileNo = response.result;
                        outbound(param).then((data)=>{
                            this.loading = false;
                            if(data.status===200){
                                this.fileList = [];
                                this.$message.success(data.message);
                                this.$refs.outbound.resetFields();
                                this.outbound.warehouseNo = "";
                                this.outbound.fileId  = "";
                                this.outbound.items = [];
                                this.activeName = "second";
                                this.selectedInstruction = null;
                                this.outbound.mainProduct = "";
                                this.getWorkingOutboundList();
                            }else{
                                this.$message.error(data.message);
                            }
                        })
                    }else{
                        this.$message.error(data.message);
                    }
                })
            },
            removeFile(){
                this.outbound.fileId = "";
            },
            upload(file){
                this.uploadForm.append('file', file.file);
            },
            /*uploadSuccess(a){
                if(a.status===200){
                    this.outbound.fileId = a.result;
                }else{
                    this.$message.error(a.message);
                    this.$refs.upload.clearFiles();
                }
            },*/
            uploadError(a){
                this.$message.error(a.message);
                this.$refs.upload.clearFiles();
            },
            changeToship(value,row){
                if(row.sub){
                    for(var i=0;i<row.sub.length;i++){
                        row.sub[i].quantity = row.sub[i].quantity*value;
                    }
                }
            },
            addEditAccessories(){
                this.editCustomization.sub.push({productNo:"",qty:1});
            },
            addAccessories(){
                this.customization.sub.push({productNo:"",qty:1});
            },
            getCustomizationProduct(){
                let param = {
                    current:this.customizationPage,
                    size:this.pageSize,
                    condition:this.filters.customizationName
                }
                this.customizationLoading = true;
                getCustomizationProduct(param).then((data)=>{
                    this.customizationLoading = false;
                    if(data.status===200){
                        this.customizationProduct = data.result.records;
                        this.customizationTotal = data.result.total;
                    }
                })
            },
            changeCustomizationPage(val){
                this.customizationPage = val;
                this.customizationVisible = true;
                this.getCustomizationProduct();
            },
            formatOutboundShipment(row,columns){
                return row.product+" * "+row.quantity;
            },
            removeInventory(row){
                this.outbound.items.splice(this.outbound.items.indexOf(row),1);

                // 如果删除一个定制化主产品时，同时要清空主产品标识
                if (row.mainProductId) {
                    this.outbound.mainProduct = "";
                }

                if(this.outbound.items.length===0){
                    this.outbound.warehouseNo = "";
                    this.outbound.user = "";
                    this.outbound.mainProduct = "";
                }
            },
            selectInventory(row){
                // row.toShip = 1;
                if(row.selected){
                    let selectedItem = this.outbound.items.find(item=>{
                        return item.productNo==row.productNo&&this.outbound.warehouseNo==item.warehouseNo
                    });
                    if(selectedItem){
                        this.outbound.items.splice(this.outbound.items.indexOf(selectedItem),1);
                    }
                    this.$set(row,"selected",false)
                    if(this.outbound.items.length==0){
                        this.outbound.warehouseNo = "";
                        this.outbound.mainProduct = "";
                    }
                    return;
                }
                this.$set(row,'toShip',1);
                let exsit = this.outbound.items.filter((item)=>{
                    return item.productNo==row.productNo&&item.warehouseNo==row.warehouseNo;
                });
                if(exsit.length>0){
                    this.$message.error("Product selected.");
                    return;
                }
                if(!this.outbound.warehouseNo){
                    this.$set(row,"selected",true)
                    this.outbound.items.push(row);
                    this.outbound.warehouseNo= row.warehouseNo;
                    this.addInventory = false;
                    this.inventroySummary = false;
                    this.outbound.user= row.warehouseUserNo
                }else{
                    if(this.outbound.warehouseNo==row.warehouseNo){
                        this.$set(row,"selected",true)
                        this.outbound.items.push(row);
                        this.addInventory = false;
                        this.inventroySummary = false;
                    }else{
                        this.$message.error("Products from different warehouses cannot be shipped out together.");
                    }
                }
            },
            eitCustomization(row){
                let param = {
                    warehouseNo: row.warehouseNo
                }
                getServiceList(param).then((data)=>{
                    if(data.status===200){
                        this.serviceList = data.result;
                    }
                })
                getProductsByWarehouseId({warehouseNo:row.warehouseNo}).then((data)=>{
                    if(data.status===200){
                        this.inventories = data.result;
                        this.editCustomization.id = row.id;
                        this.editCustomization.warehouse = row.warehouseNo;
                        this.editCustomization.mainProduct = row.mainProductId;
                        this.editCustomization.qty = row.qty;
                        let sub = row.items.filter((item)=>{
                            return item.productNo!=row.mainProductId;
                        })
                        sub.forEach((item)=>{
                            item.productNo = item.productNo.toString();
                            // item.fbm = item.fbm;
                            var inventory = this.inventories.filter((i)=>{
                                return i.productNo==item.productNo;
                            });
                            if(inventory){
                                item.fbm = inventory[0].fbm;
                            }
                        })
                        this.editCustomization.sub = sub;
                        this.editCustomization.name = row.templateName;
                        this.editCustomizationVisible = true;
                    }
                })
            },
            selectCustomization (row){
                row.qty = row.stock;
                if(!row.mainProductId){
                    this.$message.error("You must select a main product before outbound.");
                    return;
                }
                this.$set(row,"toShip",1)
                // this.inventories.splice(this.inventories.indexOf(row),1);
                row.items.forEach((item)=>{
                    item.type=3;
                })
                if(!this.outbound.warehouseNo){
                    this.outbound.items.push(row);
                    this.outbound.warehouseNo= row.warehouseNo;
                    this.customizationVisible = false;
                    this.outbound.user= row.warehouseUserNo
                }else{
                    if(this.outbound.warehouseNo==row.warehouseNo){
                        this.outbound.items.push(row);
                        this.customizationVisible = false;
                    }else{
                        this.$message.error("Products from different warehouses cannot be shipped out together.");
                    }
                }
                if(row.mainProductId){
                    this.outbound.mainProduct = row.mainProductId;
                    this.outbound.mainProductName = row.mainProductName;
                }
                this.outbound.note = row.templateName;
                // this.outbound.items.push(row);
                // this.outbound.user = row.warehouseUserNo;
                // this.customizationVisible = false;
            },
            showAddInventory(){
                this.filters.inventoryNurse = ""
                this.filters.inventorySummaryNurse = ""
                this.getInventorySummary().then((data)=>{
                    this.inventroySummary = true;
                    this.filters.inventorySummaryNurse=""
                })
            },
            getInventorySummary(){
                let param = {
                    current:this.inventorySummaryPage,
                    size:this.pageSize,
                    productName:this.filters.inventoryProductSummary,
                };
                this.inventorySummaryLoading= true;
                return getInventorySummary(param).then((data)=>{
                    this.inventorySummaryLoading= false;
                    if(data.status===200){
                        this.inventoriesSummary = data.result.records;
                        this.inventorySummaryTotal = data.result.total;
                    }
                })
            },
            getInventory(productNo){
                if(productNo){
                    this.currentInventroy = productNo;
                }
                let param = {
                    current:this.inventoryPage,
                    size:this.pageSize,
                    productName:this.filters.inventoryProduct,
                    nurseId:this.filters.inventoryNurse,
                    productNo:productNo?productNo:this.currentInventroy
                };
                this.addInventory = true;
                this.inventoryLoading= true;
                return getInventoryList(param).then((data)=>{
                    this.inventoryLoading= false;
                    if(data.status===200){
                        this.inventories = data.result.records;
                        this.inventoryTotal = data.result.total;
                        this.inventories.forEach(item=>{
                            let selected = this.outbound.items.filter(i=>{
                                return i.productNo == item.productNo && i.warehouseNo==item.warehouseNo
                            });
                            if(selected&&selected.length>0){
                                this.$set(item,"selected",true)
                            }
                        })
                    }
                })
            },
            getInventorySummaryByUser(){
                if(this.filters.inventorySummaryNurse){
                    let param = {
                        current:this.inventorySummaryByUserPage,
                        size:this.pageSize,
                        productName:this.filters.inventoryProductSummary,
                        nurseId:this.filters.inventorySummaryNurse
                    };
                    this.inventoryLoading= true;
                    return getInventoryList(param).then((data)=>{
                        this.inventoryLoading= false;
                        if(data.status===200){
                            this.inventoriesSummaryByUser = data.result.records;
                            this.inventorySummaryByUserTotal = data.result.total;
                            this.inventoriesSummaryByUser.forEach(item=>{
                                let selected = this.outbound.items.filter(i=>{
                                    return i.productNo == item.productNo && i.warehouseNo==item.warehouseNo
                                });
                                if(selected&&selected.length>0){
                                    this.$set(item,"selected",true)
                                }

                            })
                        }
                    })
                }else{
                    this.getInventorySummary();
                }
            },
            searchInventorySummary(){
                if(this.filters.inventorySummaryNurse){
                    this.getInventorySummaryByUser();
                }  else{
                    this.getInventorySummary();
                }
            },
            handleInventorySummaryByUserPageChange(val) {
                this.inventorySummaryByUserPage = val;
                this.getInventorySummaryByUser();
            },
            handleInventoryPageChange(val) {
                this.inventoryPage = val;
                this.getInventory(this.currentInventroy);
            },
            handleInventorySummaryPageChange(val) {
                this.inventorySummaryPage = val;
                this.getInventorySummary();
            },
            changeWorkingList(val){
                this.workingPage = val;
                this.getWorkingOutboundList();
            },
            getWorkingOutboundList(){
                let param = {
                    current:this.workingPage,
                    size:this.pageSize,
                    status:1,
                    condition:this.filters.workingFilter,
                    main:this.filters.workingMainFilter
                }
                this.workingLoading = true;
                getOutboundList(param).then((data)=>{
                    this.workingLoading = false;
                    if(data.status===200){
                        this.workingList = data.result.records;
                        this.workingTotal = data.result.total;
                    }
                })
            },
            getTransferList(){
                let param = {
                    current:this.transferPage,
                    size:this.pageSize,
                    condition:this.filters.transferFilter
                }
                this.transferLoading = true;
                getTransferList(param).then((data)=>{
                    this.workingLoading = false;
                    if(data.status===200){
                        this.transferList = data.result.records;
                        this.transferTotal = data.result.total;
                    }
                })
            },

            // 点击转仓日志时加载
            handleTabClick(tab) {
                if (tab.name === 'six') {
                    this.getTrasferUserLogs();
                }
            },
            // 查询用户转仓信息
            getTrasferUserLogs() {
                let param = {
                    current:this.transferLogsPage,
                    size:this.transferLogsPageSize,
                    doctorNo:this.currentUser.userNo,
                }
                this.transferLogsLoading = true;
                getTransferUserInfoByDoctorNo(param).then((data)=>{
					this.transferLogsLoading = false;
					if(data.status===200){
						this.transferLogsList = data.result.records;
						this.transferLogsWorkingTotal = data.result.total;
					}
				})
            },
            changeArchivedList(val){
                this.archivedPage = val;
                this.getArchivedOutboundList();
            },
            getArchivedOutboundList(){
                let param = {
                    current:this.archivedPage,
                    size:this.pageSize,
                    status:2,
                    condition:this.filters.archivedFilter,
                    main:this.filters.archivedMainFilter
                }
                this.archivedLoading = true;
                getOutboundList(param).then((data)=>{
                    this.archivedLoading = false;
                    if(data.status===200){
                        this.archivedList = data.result.records;
                        this.archivedTotal = data.result.total;
                    }
                })
            },
            changeCloseList(val){
                this.closePage = val;
                this.getCloseOutboundList();
            },
            changeTransferList(val){
                this.transferPage= val;
                this.getTransferList();
            },
            getCloseOutboundList(){
                let param = {
                    current:this.closePage,
                    size:this.pageSize,
                    status:3,
                    condition:this.filters.closeFilter,
                    main:this.filters.closeMainFilter
                }
                this.closeLoading = true;
                getOutboundList(param).then((data)=>{
                    this.closeLoading = false;
                    if(data.status===200){
                        this.closeList = data.result.records;
                        this.closeTotal = data.result.total;
                    }
                })
            },
            changeInstruction(selected){
                this.outbound.note = selected.instructionNote;
                this.outbound.instruction = selected.instructionText;
            },
            getInstructionList(){
                getInstructionList({}).then((data)=>{
                    if(data.status===200){
                        this.instructionTemps = data.result;
                    }
                })
            },
            handleAddInstruction(){
                this.$refs.addInstruction.validate((valid)=>{
                    if(valid){
                        let param = {
                            instructionName:this.addInstruction.name,
                            instructionText:this.addInstruction.text,
                            instructionNote:this.addInstruction.note
                        }
                        addInstruction(param).then((data)=>{
                            if(data.status===200){
                                this.$message.success(data.message);
                                this.$refs.addInstruction.resetFields();
                                this.addInstructionVisible = false;
                                this.getInstructionList();
                                this.getInstructionListByPage();
                            }else{
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            handleEditInstruction(){
                this.$refs.editInstructionObj.validate((valid)=>{
                    if(valid){
                        let param = {
                            instructionName:this.editInstructionObj.name,
                            instructionText:this.editInstructionObj.text,
                            instructionNote:this.editInstructionObj.note,
                            id:this.editInstructionObj.id
                        }
                        addInstruction(param).then((data)=>{
                            if(data.status===200){
                                this.$message.success(data.message);
                                this.$refs.editInstructionObj.resetFields();
                                this.editInstructionVisible = false;
                                this.getInstructionList();
                                this.getInstructionListByPage();
                            }else{
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            editInstruction(row){
                this.editInstructionObj.name = row.instructionName;
                this.editInstructionObj.note = row.instructionNote;
                this.editInstructionObj.text = row.instructionText;
                this.editInstructionObj.id = row.id;
                this.editInstructionVisible = true;
            },
            deleteInstruction(id){
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(()=>{
                    let param = {
                        id:id
                    };
                    deleteInstruction(param).then((data)=>{
                        if(data.status===200){
                            this.$message.success(data.message);
                            this.getInstructionListByPage()
                            this.getInstructionList()
                        }else{
                            this.$message.error(data.message)
                        }
                    })
                }).catch(()=>{})
            },
            getNurseList() {
                getDoctorNurse().then((data) => {
                    if (data.status === 200) {
                        this.nurseList = data.result;
                    }
                })
            },
            getDoctorMembers(){
                getDoctorMemberList({}).then((data) => {
                    if (data.status === 200) {
                        this.members = data.result;
                    }
                })
            },
            getWarehouse(){
                getCurrentWarehouse({}).then((data)=>{
                    if(data.status===200){
                        this.warehouses = data.result;
                    }
                })
            },
            getInstructionListByPage(){
                let param = {
                    current:this.instructionPage,
                    size:this.pageSize
                }
                this.instructionLoading = true;
                getInstructionListByPage(param).then((data)=>{
                    this.instructionLoading = false;
                    if(data.status===200){
                        this.instructionListPage = data.result.records;
                        this.instructionTotal = data.result.total;
                        this.instructionTemplateVisiable = true;
                    }
                })
            },
            handleChangeInstructionListByPage(val){
                this.instructionPage = val;
                this.getInstructionListByPage();
            },
            showProductList(){
                this.fbmModelVisiable = true;
                this.getTransferProductList();
            },
            getTransferProductList(){
                let param = {
                    current:this.productPage,
                    size:this.pageSize,
                    condition:this.filters.productFilter
                }
                this.productLoading = true;
                getInventory(param).then((res) => {
                    this.productLoading = false;
                    if(res.status===200){
                        this.productList = res.result.records;
                        this.productTotal = res.result.total;
                    }
                });
            },
            handleProductPageChange(val){
                this.productPage = val;
                this.getTransferProductList();
            },
            showWarehouseFBM(productNo){
                this.fbmModelVisiable = true;
                this.currentDetailNo = productNo;
                this.getInventoryDetail();
            },
            getInventoryDetail(){
                let param = {
                    current:this.fbmPage,
                    size:this.pageSize,
                    productName:this.filters.fbmFilter,
                    productNo:this.currentDetailNo,
                    warehouseOnly:"1"
                };
                this.fbmLoading= true;
                return getInventoryList(param).then((data)=>{
                    this.fbmLoading= false;
                    if(data.status===200){
                        this.fbmDetail = data.result.records;
                        this.fbmTotal = data.result.total;
                    }
                })
            },
            handleInventoryDetailPageChange(val) {
                this.fbmPage = val;
                this.getInventoryDetail();
            },
            showTransfer(productNo,warehouseNo){
                getProductFBM({productId:productNo,warehouseNo:warehouseNo}).then((data)=>{
                    this.transferModelVisiable= true;
                    this.transferForm.to="";
                    this.transferForm.transferQty = "";
                    if(data.status===200){
                        this.transferForm.productName = data.result.productNme;
                        this.transferForm.qty = data.result.qty;
                        this.transferForm.warehouse = data.result.warehouse;
                        this.transferForm.upc = data.result.upc;
                        this.transferForm.productNo = productNo;
                        this.transferForm.warehouseNo = warehouseNo;
                    }
                })
            },
            transferTo(){
                this.$refs.transferForm.validate((valid)=>{
                    if(valid){
                        this.loading = true;
                        transferTo(this.transferForm).then((data)=>{
                            this.loading = false;
                            if(data.status===200){
                                this.$message.success("Transfer Success.");
                                this.transferModelVisiable = false;
                                this.getTransferProductList();
                                this.getInventoryDetail();
                            }else{
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            // getServiceList(){
            //     getServiceList({}).then((data)=>{
            //         if(data.status===200){
            //             this.serviceList = data.result;
            //         }
            //     })
            // }
        },
        mounted() {
            this.getWorkingOutboundList();
            this.getArchivedOutboundList();
            this.getCloseOutboundList();
            this.getInstructionList();
            this.getNurseList();
            this.getDoctorMembers();
            this.getWarehouse();
            this.getTransferProductList();
            // this.getServiceList();
            let active = this.$route.params.active;
            if(active){
                this.activeName = active;
            }
            
            let user = sessionStorage.getItem('user')
            user = JSON.parse(user);
            this.currentUser = user;
        }
    }

</script>


// WEBPACK FOOTER //
// outbound.vue?3d0f369d